<template>
    <div>
        <div class="giftcard-details-form vue-form">
            <div class="vue-form-row">
                <vue-input
                    :element="blikPincodeField"
                    :key="blikPincodeField.id"
                    tabindex=""
                    @blur="updatePincode(blikPincodeField.id, $event.target.value)">
                </vue-input>
            </div>
        </div>
    </div>
</template>

<script src='./blik.js'></script>
